import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AdminShell from "@/components/admin/AdminShell";
import { LogoLoader } from "@/components/LogoLoader";
import { isAdminRole } from "@/lib/accountRole";

// `/admin` layout route. Wrapped by <ProtectedRoute> (login gate), so here
// we only enforce the admin-role gate, then render the portal shell whose
// <Outlet/> resolves the active section page.
export default function AdminPortal() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <LogoLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdminRole(user.role)) return <Navigate to="/feed" replace />;
  return <AdminShell />;
}
